(function () {
  if (document.body.dataset.template !== 'index') return;

  const sections = document.querySelectorAll('#MainContent > .shopify-section');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion && sections.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    sections.forEach((section, index) => {
      if (index === 0) {
        section.classList.add('is-visible');
        return;
      }

      observer.observe(section);
    });
  } else {
    sections.forEach((section) => section.classList.add('is-visible'));
  }

  let scrollTicking = false;

  const updateScrollState = () => {
    document.body.classList.toggle('is-scrolled', window.scrollY > 24);
    scrollTicking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(updateScrollState);
    },
    { passive: true }
  );

  updateScrollState();

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.button:not(.button-unstyled), .button-secondary');

      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      button.classList.add('is-clicked');
      window.setTimeout(() => button.classList.remove('is-clicked'), 180);
    },
    { passive: true }
  );
})();
